import React, {useEffect, useState} from "react";
import {
    dashboardCountFxn,
    dateOpenFxn,
    dayCloseFxn,
    fetchOrderListFxn,
    getCurrentDayOpenFxn,
    paymentGroupByPaymentMethodFxn,
    deleteTodayDayFxn
} from "./action";
import OrderListDashboard from "../order/orderListDashboard";
import ProductListDashboard from "../products/productListDashboard";
import _ from "lodash"
import {Button, Popconfirm} from "../../components/Elements/appUtils";
import {useDispatch} from "react-redux";
import moment from "moment";
import {getItemLocalstorage} from "../../components/_utils/_utils";


let initPaymentMode = [
    {name: "Card", value: 0},
    {name: "Cash", value: 0},
    {name: "UPI", value: 0},
    {name: "Total", value: 0}
]
let initState = {
    totalOrder: 0,
    totalCustomer: 0,
    totalKot: 0,
    totalProduct: 0,
}
const Dashboard = () => {
    let dispatch = useDispatch()
    const [paymentData, setPaymentData] = useState(initPaymentMode)
    const [dayOpening, setDayOpening] = useState(false);
    const [dayClosing, setDayClosing] = useState(false);
    const [currentDayOpen, setCurrentDayOpen] = useState({});
    const [state, setState] = useState(initState)
    const apiRequest = async (params) => {
        const {data} = await dashboardCountFxn({...params});
        setState(data);
    };


    const loadPaymentData = async () => {
        const {data} = await paymentGroupByPaymentMethodFxn({});
        let cloneDoc = _.clone(initPaymentMode);
        _.each(cloneDoc, (item) => {
            let findVal = _.find(data, (doc) => {
                return doc._id == item.name.toLowerCase()
            })
            if (findVal) {
                item.value = findVal.totalAmount.toFixed(2)
            }
        })
        setPaymentData(cloneDoc)
    };

    const loadCurrentDay = async () => {
        const {data} = await getCurrentDayOpenFxn({});
        setCurrentDayOpen(data)
    };

    const handleDayOpen = async () => {
        try {
            setDayOpening(true);

            const resp = await dispatch(dateOpenFxn());

            if (resp && resp.success) {
                apiRequest();
                loadPaymentData();
                loadCurrentDay()
            }
        } catch (error) {
            console.error("Day open failed", error);
        } finally {
            setDayOpening(false);
        }
    };

    const handleCloseDay = async () => {
        try {
            setDayClosing(true);

            const resp = await dispatch(dayCloseFxn());

            if (resp && resp.success) {
                apiRequest();
                loadPaymentData();
                loadCurrentDay()
            }
        } catch (error) {
            console.error("Day close failed", error);
        } finally {
            setDayClosing(false);
        }
    };
    const handleDeleteToday = async () => {
        try {
            const resp = await dispatch(deleteTodayDayFxn());

            if (resp && resp.success) {
                apiRequest();
                loadPaymentData();
                loadCurrentDay();
            }
        } catch (error) {
            console.error("Delete today failed", error);
        }
    };

    useEffect(() => {
        apiRequest()
        loadPaymentData()
        loadCurrentDay()
    }, [])

    const userType = getItemLocalstorage("user")["userType"];

    return (
        <>
            <div className="main-wrapper">
                <div className="page-wrapper-2">
                    <div className="content">
                        {
                            ['cashier', 'admin'].includes(userType) &&
                            <div className="d-flex justify-content-end mb-3">
                                <div
                                    // className="d-flex align-items-center justify-content-between px-3 py-2"
                                    className="d-flex align-items-center gap-3 flex-wrap px-3 py-2"
                                    style={{
                                        minWidth: "fitContent",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: "8px",
                                        backgroundColor: "#f9fafb"
                                    }}>
                                    {/*<Popconfirm*/}
                                    {/*    title="Are you sure you want to delete today's entry?"*/}
                                    {/*    onConfirm={handleDeleteToday}*/}
                                    {/*    okText="Yes"*/}
                                    {/*    cancelText="No"*/}
                                    {/*>*/}
                                    {/*    <Button className={'ms-3'}>*/}
                                    {/*        Delete Today*/}
                                    {/*    </Button>*/}
                                    {/*</Popconfirm>*/}

                                    {currentDayOpen ? (
                                        <>

                                            {
                                                currentDayOpen.status != 'closed' ?
                                                    <div>
                                                        <div className="text-muted" style={{fontSize: "12px"}}>
                                                            Day Opened On
                                                        </div>
                                                        <div className="fw-semibold">
                                                            {moment(currentDayOpen.dayOpenDate).format("DD MMM - HH:MM A")}
                                                        </div>
                                                    </div> :
                                                    <div>
                                                        <div className="text-muted" style={{fontSize: "12px"}}>
                                                            Day Closed On
                                                        </div>
                                                        <div className="fw-semibold">
                                                            {moment(currentDayOpen.dayCloseDate).format("DD MMM - HH:MM A")}
                                                        </div>
                                                    </div>
                                            }

                                            {
                                                currentDayOpen.status != 'closed' &&
                                                <Popconfirm
                                                    title="Are you sure you want to close the day?"
                                                    onConfirm={handleCloseDay}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button
                                                        disabled={dayClosing}
                                                        className={'ms-3'}
                                                    >
                                                        {dayClosing ? "Closing..." : "Close Day"}
                                                    </Button>
                                                </Popconfirm>
                                            }

                                        </>
                                    ) : (
                                        <>
                                            <div>
                                                <div className="text-muted" style={{fontSize: "12px"}}>
                                                    Day Status
                                                </div>
                                                <div className="fw-semibold text-danger">
                                                    Not Opened
                                                </div>
                                            </div>

                                            {/*<Button*/}
                                            {/*    onClick={handleDayOpen}*/}
                                            {/*    disabled={dayOpening}*/}
                                            {/*    className={'ms-3'}*/}
                                            {/*>*/}
                                            {/*    {dayOpening ? "Opening..." : "Open Day"}*/}
                                            {/*</Button>*/}
                                            <Popconfirm
                                                title="Are you sure you want to open the day?"
                                                onConfirm={handleDayOpen}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Button
                                                    disabled={dayOpening}
                                                    className={'ms-3'}
                                                >
                                                    {dayOpening ? "Opening..." : "Open Day"}
                                                </Button>
                                            </Popconfirm>
                                        </>
                                    )}

                                    {userType === "admin" &&
                                        <Popconfirm
                                            title="Are you sure you want to delete today's entry?"
                                            onConfirm={handleDeleteToday}
                                            okText="Yes"
                                            cancelText="No">
                                            <Button
                                                type="danger"
                                                className="ms-1">
                                                Delete Today
                                            </Button>
                                        </Popconfirm>
                                    }
                                </div>

                            </div>

                        }
                        {/* <div className="row">
                            {paymentData && paymentData.length ? paymentData.map((item) => {
                                return (
                                    <div className="col-lg-3 col-sm-6 col-12" key={item.name}>
                                        <div className="dash-widget">
                                            <div className="dash-widgetimg">
                                        <span>
                                          <img src="assets/img/icons/dash1.svg" alt="img"/>
                                        </span>
                                            </div>
                                            <div className="dash-widgetcontent">
                                                <h5>
                                          <span className="counters" data-count={item.value}>
                                            Rs. {item.value}
                                          </span>
                                                </h5>
                                                <h6>{item.name}</h6>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) : null}


                        </div>*/}
                        <div className={'row'}>
                            <div className="col-lg-3 col-sm-6 col-12 d-flex">
                                <div className="dash-count">
                                    <div className="dash-counts">
                                        <h4>{state.totalCustomer}</h4>
                                        <h5>Total Customer</h5>
                                    </div>
                                    <div className="dash-imgs">
                                        <i className={'fa fa-user'}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12 d-flex">
                                <div className="dash-count">
                                    <div className="dash-counts">
                                        <h4>{state.totalProduct}</h4>
                                        <h5>Total Product</h5>
                                    </div>
                                    <div className="dash-imgs">
                                        <i className={'fa fa-user'}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12 d-flex">
                                <div className="dash-count">
                                    <div className="dash-counts">
                                        <h4>{state.totalOrder}</h4>
                                        <h5>Total Order</h5>
                                    </div>
                                    <div className="dash-imgs">
                                        <i className={'fa fa-user'}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12 d-flex">
                                <div className="dash-count">
                                    <div className="dash-counts">
                                        <h4>{state.totalKot}</h4>
                                        <h5>Total KOT</h5>
                                    </div>
                                    <div className="dash-imgs">
                                        <i className={'fa fa-user'}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 col-sm-12 col-12 d-flex">
                                <div className="card flex-fill">
                                    <div className="card-body">
                                        <OrderListDashboard/>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="card mb-0">
                            <div className="card-body">
                                <div className="table-responsive dataview">
                                    <ProductListDashboard/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Dashboard;
